import {
  property,
  subclass,
} from "@arcgis/core/core/accessorSupport/decorators";
import Accessor from "@arcgis/core/core/Accessor";
import Handles from "@arcgis/core/core/Handles";

import AppT9N from "../../../t9n/App/App.json";

import { PopoverIds } from "./PopoverManager";

export interface PopoverDefinition {
  refElementId: PopoverIds;
  title: string;
  content: string;
  icon?: string;
  badgeString?: string;
}

const popoverIcons = {
  popover1: "search",
  popover2: "analysis",
  popover3: "list-bullet",
  popover4: "chevron-down",
  popover5: "applications",
  popover6: "copy",
};

const getStartedIcons = {
  tip1: "apps",
  tip2: "analysis",
  tip3: "duplicate",
  tip4: "search",
  tip5: "article",
  tip6: "blog",
};

export function assignPopoverId(index: number): PopoverIds {
  return `popover${index}` as PopoverIds;
}

@subclass("Landing.widgets.PopoverOnboarding.PopoverManagerViewModel")
export default class PopoverManagerViewModel extends Accessor {
  // ----------------------------------
  //
  //  Public Variables
  //
  // ----------------------------------

  @property()
  appMessages: typeof AppT9N;

  @property()
  popovers: PopoverDefinition[];

  @property()
  gettingStartedTips: PopoverDefinition[];

  // ----------------------------------
  //
  //  Private Variables
  //
  // ----------------------------------
  private _handles: Handles = new Handles();

  // ----------------------------------
  //
  //  Lifecycle methods
  //
  // ----------------------------------
  constructor(params: any) {
    super(params);
  }

  initialize() {}

  createPopovers() {
    const { popoverOnboardingDefs, gettingsStartedDefs } = this.appMessages;

    this.popovers = Object.entries(popoverOnboardingDefs).map(
      ([key, popover]) => {
        return {
          refElementId: key as PopoverIds,
          title: popover.title,
          content: popover.content,
          icon: popoverIcons[key as PopoverIds],
          badgeString: popover?.badgeString,
        };
      }
    );

    this.gettingStartedTips = Object.entries(gettingsStartedDefs).map(
      ([key, popover]) => {
        return {
          refElementId: key as any,
          title: popover.title,
          content: popover.content,
          icon: getStartedIcons[key as any],
          badgeString: popover?.badgeString,
        };
      }
    );
  }
}
